<app-wg-crud-table [title]="config.title" [fields]="config.fields" [service]="service" [supportsAdditionalImages]="config.supportsAdditionalImages ?? false"></app-wg-crud-table>
